import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export const introductionVideo = () => {






	document.querySelectorAll('.video[data-video-status]').forEach(function (videoContainer) {
		const videoEl = videoContainer.querySelector('video');

		videoEl.style.display = 'none';

		videoContainer.addEventListener('click', function () {
			const isActive = videoContainer.getAttribute('data-video-status') === 'active';

			if (!isActive) {
				videoEl.style.display = 'block';
				videoEl.muted = false;
				videoEl.play();
				videoContainer.setAttribute('data-video-status', 'active');
			} else {
				videoEl.pause();
				videoEl.currentTime = 0;
				videoEl.style.display = 'none';
				videoContainer.setAttribute('data-video-status', 'inactive');
			}
		});
	});





}

export default () => { }